module.exports = __webpack_public_path__ + "fonts/nexa-bold-webfont.e997b5e8.woff";